import type { ICellLocation } from "@dmca/models/interface/cell-location";
import { AutoComplete, type AutoCompleteProps } from "./AutoComplete";
import { forwardRef } from "react";

export interface CellLocationAutoCompleteProps<
  Multiple extends boolean | undefined,
  DisableClearable extends boolean | undefined
> extends Omit<
    AutoCompleteProps<ICellLocation, Multiple, DisableClearable, false>,
    "options"
  > {
  cells: ICellLocation[];
}

function CellLocationAutoCompleteInner<
  Multiple extends boolean | undefined,
  DisableClearable extends boolean | undefined
>(
  { cells, ...rest }: CellLocationAutoCompleteProps<Multiple, DisableClearable>,
  ref: any
) {
  return (
    <AutoComplete
      ref={ref}
      options={cells.toSorted(
        (x, y) =>
          x.plantName.localeCompare(y.plantName) ||
          x.locationName.localeCompare(y.locationName)
      )}
      getOptionLabel={(option) => option.locationName}
      groupBy={(option) => option.plantName}
      label="Select Location"
      {...rest}
    />
  );
}

export const CellLocationAutoComplete = forwardRef(
  CellLocationAutoCompleteInner
) as <
  Multiple extends boolean | undefined = false,
  DisableClearable extends boolean | undefined = false
>(
  props: CellLocationAutoCompleteProps<Multiple, DisableClearable> & {
    ref?: React.ForwardedRef<HTMLDivElement>;
  }
) => ReturnType<typeof CellLocationAutoCompleteInner>;
